export const includedServiceKinds = ['officer', 'maintenance', 'cleaning'];
export const includedServiceLabels = { officer: 'Operations Officer', maintenance: 'Routine maintenance', cleaning: 'Cleaning' };
export const serviceRateBases = ['Unknown', 'Included', 'Hourly', 'Per visit', 'Monthly', 'Annual', 'Other', 'Agree before instruction'];
export const emptyServiceRate = () => ({ basis: 'Unknown', amount: null, vat: 'Unknown', detail: '' });
export const emptyIncludedService = () => ({ state: 'Unknown', exclusionReason: '', delivery: 'Unknown', hours: null, hoursPeriod: 'Unknown', attendance: '', scope: '', exclusions: '', reporting: '', staffIds: [], contractIds: [], rate: emptyServiceRate(), materials: '', ppmFrequency: '', emergencyCallout: '', outOfHoursRate: emptyServiceRate(), areas: '', consumables: '', windows: '', waste: '' });
export const emptyIncludedServices = () => ({ effectiveFrom: null, effectiveTo: null, appointmentId: null, documentId: null, documentVersionId: null, agreementVersionId: null, services: { officer: emptyIncludedService(), maintenance: emptyIncludedService(), cleaning: emptyIncludedService() }, management: { state: 'Unknown', exclusionReason: '', inspectionFrequency: '', inspectionReporting: '', directorMeetings: '', agm: '', additionalMeetings: emptyServiceRate(), exceptions: '' }, overlapReview: 'Unknown', overlapExplanation: '', notes: '' });
export function serviceRateGaps(rate, label, allowConditional = false) {
    if (rate.basis === 'Agree before instruction')
        return !allowConditional ? [`${label}: agree the rate before this service is instructed`] : rate.amount !== null ? [`${label}: a conditional rate must not contain an agreed amount`] : rate.detail.trim() ? [] : [`${label}: record the conditional charging terms`];
    const missing = [];
    if (rate.basis === 'Unknown')
        missing.push(`${label}: confirm included or chargeable`);
    else if (rate.basis !== 'Included') {
        if (rate.amount === null)
            missing.push(`${label}: agreed amount`);
        if (rate.vat === 'Unknown')
            missing.push(`${label}: VAT basis`);
        if (rate.basis === 'Other' && !rate.detail.trim())
            missing.push(`${label}: charging basis`);
    }
    return missing;
}
/** A saved contractual service schedule is distinct from future operational assignments. */
export function includedServicesGaps(f, options = {}) {
    const missing = [];
    if (!f.effectiveFrom)
        missing.push('Service effective date');
    if (f.effectiveFrom && f.effectiveTo && f.effectiveTo < f.effectiveFrom)
        missing.push('Service dates must be in order');
    for (const kind of includedServiceKinds) {
        const s = f.services[kind], label = includedServiceLabels[kind];
        if (s.state === 'Unknown') {
            missing.push(`${label}: confirm included or excluded`);
            continue;
        }
        if (s.state === 'Excluded') {
            if (!s.exclusionReason.trim())
                missing.push(`${label}: contractual exclusion basis`);
            continue;
        }
        for (const [name, known] of [['Delivery arrangement', s.delivery !== 'Unknown'], ['Included hours', s.hours !== null], ['Hours period', s.hoursPeriod !== 'Unknown'], ['Attendance', s.attendance], ['Scope', s.scope], ['Exclusions (or explicit none)', s.exclusions], ['Reporting', s.reporting]])
            if (!known)
                missing.push(`${label}: ${name}`);
        // C-206: the agreement's service schedule is recorded as-is; mapping staff and existing contracts to it can follow after go-live.
        missing.push(...serviceRateGaps(s.rate, `${label} agreed rate`));
        if (kind === 'maintenance') {
            if (!s.ppmFrequency.trim())
                missing.push('Routine maintenance: PPM frequency');
            if (!s.materials.trim())
                missing.push('Routine maintenance: materials basis');
            if (!s.emergencyCallout.trim())
                missing.push('Routine maintenance: emergency call-out arrangements');
            missing.push(...serviceRateGaps(s.outOfHoursRate, 'Routine maintenance out-of-hours rate'));
        }
        if (kind === 'cleaning')
            for (const [name, value] of [['Areas', s.areas], ['Consumables', s.consumables], ['Windows', s.windows], ['Waste', s.waste]])
                if (!value.trim())
                    missing.push(`Cleaning: ${name}`);
    }
    if (f.management.state === 'Unknown')
        missing.push('Management services: confirm included or excluded');
    else if (f.management.state === 'Excluded') {
        if (!f.management.exclusionReason.trim())
            missing.push('Management services: contractual exclusion basis');
    }
    else {
        for (const [name, value] of [['Inspection frequency', f.management.inspectionFrequency], ['Inspection report timing', f.management.inspectionReporting], ['Director meetings', f.management.directorMeetings], ['AGM', f.management.agm], ['Contractual exceptions (or explicit none)', f.management.exceptions]])
            if (!value.trim())
                missing.push(`Management services: ${name}`);
        missing.push(...serviceRateGaps(f.management.additionalMeetings, 'Additional meetings', options.allowConditionalAdditionalMeetings !== false));
    }
    return missing;
}
//# sourceMappingURL=included-services.js.map